import './jquery.js';
import Swiper from 'swiper';
import 'featherlight';
// import Tablesaw from 'tablesaw';

const OPTIONS = {
  navigation: {
    desktop: {
      primaryListClass: '.d-header__navigation-list--primary',
      primaryListLinkClass: '.d-header__navigation-list-item-link',
      secondaryContentClass: '.d-header__navigation-content--secondary',
    },
    mobile: {
      primaryListClass: '.m-header__navigation-list--primary',
      primaryListLinkClass: '.m-header__navigation-list-item-link',
      secondaryContentClass: '.m-header__navigation-content--secondary',
      alternativeWrapperClass: '.m-header__ephemeral-wrapper',
    },
  },
  swiper: {
    heroSwiperClass: '.js--swiper-hero',
    contentSwiperClass: '.js--swiper-content',
  },
};
const toggleDesktopSecondaryNavigation = function (clickedElement) {
  $(OPTIONS.navigation.desktop.secondaryContentClass).hide();
  $(clickedElement).siblings(OPTIONS.navigation.desktop.secondaryContentClass).first().css('display', 'flex');
};

const toggleCurrentDesktopSecondaryNavigation = function (clickedElement) {
  $(OPTIONS.navigation.desktop.secondaryContentClass).hide();
  $(clickedElement).siblings('a').first().trigger('mouseover');
  $(clickedElement).first().css('display', 'flex');
};

const toggleDesktopPrimaryNavigationState = function (clickedElement) {
  $(OPTIONS.navigation.desktop.primaryListLinkClass).removeClass('d-header__navigation-list-item-link--active');
  $(clickedElement).toggleClass('d-header__navigation-list-item-link--active');
  $('.header--overlay').css('opacity', 0.75);
};

const resetDesktopPrimaryNavigationState = function () {
  $(OPTIONS.navigation.desktop.primaryListLinkClass).removeClass('d-header__navigation-list-item-link--active');
  $(OPTIONS.navigation.desktop.secondaryContentClass).hide();
  $('.header--overlay').css('opacity', 0);
};

const toggleMobileSecondaryNavigation = function (clickedElement) {
  $(clickedElement).siblings(OPTIONS.navigation.mobile.secondaryContentClass).first().slideToggle();
};

const toggleMobilePrimaryNavigation = function () {
  $(OPTIONS.navigation.mobile.alternativeWrapperClass).first().slideToggle();
};

const attachNavigationEvents = function () {
  $('.js--desktop-navigation-primary-link').on('mouseenter focusin', function () {
    toggleDesktopSecondaryNavigation($(this));
    toggleDesktopPrimaryNavigationState($(this));
  });
  $('.js--desktop-navigation-primary-link').on('mouseleave', function () {
    resetDesktopPrimaryNavigationState();
  });
  $('.js--desktop-navigation-secondary-content').on('mouseenter', function () {
    toggleCurrentDesktopSecondaryNavigation($(this));
  });
  $('.js--desktop-navigation-secondary-content').on('mouseleave', function () {
    resetDesktopPrimaryNavigationState();
  });
  $('.js--mobile-navigation-primary-icon').on('click', function () {
    toggleMobilePrimaryNavigation();
  });
  $('.js--mobile-navigation-primary-link').on('click', function () {
    toggleMobileSecondaryNavigation($(this));
  });
  $('.js--navigation-secondary-list-item').on('focusout', function () {
    resetDesktopPrimaryNavigationState();
  });
};

$(document).ready(function () {
  $(OPTIONS.navigation.mobile.secondaryContentClass).slideUp();
  new Swiper('.multi-content-slider', {
    speed: 400,
    spaceBetween: 100,
    navigation: {
      nextEl: '.multi-content-slider .swiper-button-next',
      prevEl: '.multi-content-slider .swiper-button-prev',
    },
    pagination: {
      el: '.multi-content-slider .swiper-pagination',
      type: 'bullets',
    },
  });

  $('.accordion-list__list-item-body').hide();
  $('.accordion-list__list-item-heading').on('click', function () {
      if ($(this).hasClass('accordion-list__list-item-heading--active')) {
        $(this).siblings('.accordion-list__list-item-body').slideUp(150);
        $(this).removeClass('accordion-list__list-item-heading--active');
      } else {
        $('.accordion-list__list-item-body').slideUp(150);
        $('.accordion-list__list-item-heading').removeClass('accordion-list__list-item-heading--active');
        $(this).addClass('accordion-list__list-item-heading--active');
        $(this).siblings('.accordion-list__list-item-body').slideDown(150);
      }
  });

//   Tablesaw.init();
  attachNavigationEvents();
});
